import { render, staticRenderFns } from "./JudgementList.vue?vue&type=template&id=9fbc6318&"
import script from "./JudgementList.vue?vue&type=script&lang=ts&"
export * from "./JudgementList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports